import { useRouteMatch } from 'react-router-dom';
import { useReleaseFlag } from 'hooks/useReleaseFlags';
import { MAP_PIN_ROUTE_MATCH_PATHS } from '../../../constants';
import { useMapPinEnabled } from './useMapPin';

export const useIsMapPinActive = (): boolean => {
  const mapPinEnabled = useMapPinEnabled();
  const pinImprovements = useReleaseFlag('pin_drop_improvements');
  const isPinRoute = Boolean(
    useRouteMatch({ path: MAP_PIN_ROUTE_MATCH_PATHS, exact: true }),
  );

  if (!mapPinEnabled) {
    return false;
  }

  if (pinImprovements) {
    return isPinRoute;
  }

  return true;
};
